<template>
  <transition name="fade">
    <div class="connectivity-notice" v-show="showConnectivityNotice">
      <i class="fas fa-times mr-2" v-on:click="onDismiss"></i>
      <span class="ml-2 mr-4">Connection error</span>
      <button v-on:click="onRefresh" class="notice ml-4" v-show="isOnline">Reload</button>
    </div>
  </transition>
</template>
<script>

import { mapState } from 'vuex'

export default {
  computed: mapState({
    showConnectivityNotice: state => state.showConnectivityNotice
  }),
  methods: {
    onRefresh () {
      location.reload(true)
    },
    onDismiss () {
      this.$store.commit('hideConnectivityNotice')
    }
  }
}
</script>
